
import React, { useEffect, useRef, useState } from "react";
import background from "../assets/background.webp";
import { useTranslation } from "react-i18next";

import cert1 from "../assets/certificates/01.jpg";
import cert2 from "../assets/certificates/02.jpg";
import cert3 from "../assets/certificates/03.jpg";
import cert4 from "../assets/certificates/04.jpg";
import cert5 from "../assets/certificates/05.png";
import cert6 from "../assets/certificates/06.jpg";
import cert7 from "../assets/certificates/07.jpg";
import cert8 from "../assets/certificates/08.jpg";
import cert9 from "../assets/certificates/09.jpg";
import cert10 from "../assets/certificates/10.jpg";
import cert11 from "../assets/certificates/11.jpg";

const Certificates = () => {
  const { t } = useTranslation();

  const certificates = [
    cert1,
    cert2,
    cert3,
    cert4,
    cert5,
    cert6,
    cert7,
    cert8,
    cert9,
    cert10,
    cert11,
  ];

  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    const section = sectionRef.current;

    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.05,
      }
    );

    observer.observe(section);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") {
        setActiveImage(null);
      }
    };

    window.addEventListener("keydown", handleKey);

    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, []);

  // Запрещаем прокрутку страницы при открытом изображении
  useEffect(() => {
    if (activeImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [activeImage]);

  return (
    <section
      ref={sectionRef}
      className="w-full min-h-screen py-24 px-6 bg-slate-800 flex flex-col items-center bg-center"
      style={{ backgroundImage: `url(${background})` }}
    >
      {/* TITLE */}
      <div
        className={`text-center pt-24 max-sm:pt-6 transition-all duration-700 ${
          visible
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10"
        }`}
      >
        <h1 className="font-['Cormorant_Garamond'] text-white uppercase text-[20px] md:text-[64px] tracking-[0.15em]">
          {t("certificates_page_title")}
        </h1>

        <p className="text-yellow-400 tracking-[0.4em] uppercase mt-4 text-sm">
          {t("certificates_page_subtitle")}
        </p>
      </div>

      {/* GRID */}
      <div className="mt-14 w-full max-w-6xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {certificates.map((img, i) => (
          <div
            key={img}
            onClick={() => setActiveImage(img)}
            className={`
              cursor-pointer
              h-[420px]
              group relative overflow-hidden
              border border-white/10
              shadow-[10px_10px_0_#eab308]
              hover:shadow-[20px_20px_0_#eab308]
              transition-all duration-500 ease-out
              hover:-translate-y-1
              ${
                visible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }
            `}
            style={{
              transitionDelay: visible
                ? `${Math.min(i * 80, 400)}ms`
                : "0ms",
            }}
          >
            <img
              src={img}
              alt={`Certificate ${i + 1}`}
              loading={i < 3 ? "eager" : "lazy"}
              className="
                w-full h-full object-contain bg-white
                transition-transform duration-700
                group-hover:scale-105
              "
            />

            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition" />
          </div>
        ))}
      </div>

      {/* MODAL */}
      {activeImage && (
        <div
          onClick={() => setActiveImage(null)}
          className="fixed inset-0 z-[99999] bg-black/80 flex items-center justify-center p-6"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative max-w-5xl w-full"
          >
            <button
              onClick={() => setActiveImage(null)}
              aria-label="Close image"
              className="absolute -top-10 right-0 text-white text-2xl"
            >
              ✕
            </button>

            <img
              src={activeImage}
              alt="Certificate"
              className="w-full max-h-[80vh] object-contain rounded-xl shadow-2xl"
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Certificates;
